import _regeneratorRuntime from "C:\\Users\\nanma\\Documents\\GitHub\\star\\node_modules\\@babel\\runtime/regenerator";
import _slicedToArray from "C:\\Users\\nanma\\Documents\\GitHub\\star\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";

var _marked =
/*#__PURE__*/
_regeneratorRuntime.mark(iterateMap),
    _marked2 =
/*#__PURE__*/
_regeneratorRuntime.mark(iterateSet),
    _marked3 =
/*#__PURE__*/
_regeneratorRuntime.mark(iterateImSet),
    _marked4 =
/*#__PURE__*/
_regeneratorRuntime.mark(iterateImArray),
    _marked5 =
/*#__PURE__*/
_regeneratorRuntime.mark(iterateArray),
    _marked6 =
/*#__PURE__*/
_regeneratorRuntime.mark(iterateObject),
    _marked7 =
/*#__PURE__*/
_regeneratorRuntime.mark(iterateImObject);

import { isarray, isindex } from "./array.js";
import inspectExpanded from "./expanded.js";
import formatSymbol from "./formatSymbol.js";
import inspectName from "./inspectName.js";
import { inspect, replace } from "./inspect.js";
import { isown, symbolsof, tagof, valueof } from "./object.js";
import { immutableName } from "./immutable.js";

function hasSelection(elem) {
  var sel = window.getSelection();
  return sel.type === "Range" && (sel.containsNode(elem, true) || sel.anchorNode.isSelfOrDescendant(elem) || sel.focusNode.isSelfOrDescendant(elem));
}

export default function inspectCollapsed(object, shallow, name) {
  var arrayish = isarray(object);
  var tag, fields, next, n;

  if (object instanceof Map) {
    tag = "Map(".concat(object.size, ")");
    fields = iterateMap;
  } else if (object instanceof Set) {
    tag = "Set(".concat(object.size, ")");
    fields = iterateSet;
  } else if (arrayish) {
    tag = "".concat(object.constructor.name, "(").concat(object.length, ")");
    fields = iterateArray;
  } else if (n = immutableName(object)) {
    tag = "Immutable.".concat(n.name).concat(n.name === 'Record' ? '' : "(".concat(object.size, ")"));
    arrayish = n.arrayish;
    fields = n.arrayish ? iterateImArray : n.setish ? iterateImSet : iterateImObject;
  } else {
    tag = tagof(object);
    fields = iterateObject;
  }

  if (shallow) {
    var _span = document.createElement("span");

    _span.className = "observablehq--shallow";

    if (name) {
      _span.appendChild(inspectName(name));
    }

    _span.appendChild(document.createTextNode(tag));

    _span.addEventListener("mouseup", function (event) {
      if (hasSelection(_span)) return;
      event.stopPropagation();
      replace(_span, inspectCollapsed(object));
    });

    return _span;
  }

  var span = document.createElement("span");
  span.className = "observablehq--collapsed";

  if (name) {
    span.appendChild(inspectName(name));
  }

  var a = span.appendChild(document.createElement("a"));
  a.innerHTML = "<svg width=8 height=8 class='observablehq--caret'>\n    <path d='M7 4L1 8V0z' fill='currentColor' />\n  </svg>";
  a.appendChild(document.createTextNode("".concat(tag).concat(arrayish ? " [" : " {")));
  span.addEventListener("mouseup", function (event) {
    if (hasSelection(span)) return;
    event.stopPropagation();
    replace(span, inspectExpanded(object, null, name));
  }, true);
  fields = fields(object);

  for (var i = 0; !(next = fields.next()).done && i < 20; ++i) {
    if (i > 0) span.appendChild(document.createTextNode(", "));
    span.appendChild(next.value);
  }

  if (!next.done) span.appendChild(document.createTextNode(", …"));
  span.appendChild(document.createTextNode(arrayish ? "]" : "}"));
  return span;
}

function iterateMap(map) {
  var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _ref3, _ref2, key, value;

  return _regeneratorRuntime.wrap(function iterateMap$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _iteratorNormalCompletion = true;
          _didIteratorError = false;
          _iteratorError = undefined;
          _context.prev = 3;
          _iterator = map[Symbol.iterator]();

        case 5:
          if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
            _context.next = 15;
            break;
          }

          _ref3 = _step.value;
          _ref2 = _slicedToArray(_ref3, 2);
          key = _ref2[0];
          value = _ref2[1];
          _context.next = 12;
          return formatMapField(key, value);

        case 12:
          _iteratorNormalCompletion = true;
          _context.next = 5;
          break;

        case 15:
          _context.next = 21;
          break;

        case 17:
          _context.prev = 17;
          _context.t0 = _context["catch"](3);
          _didIteratorError = true;
          _iteratorError = _context.t0;

        case 21:
          _context.prev = 21;
          _context.prev = 22;

          if (!_iteratorNormalCompletion && _iterator.return != null) {
            _iterator.return();
          }

        case 24:
          _context.prev = 24;

          if (!_didIteratorError) {
            _context.next = 27;
            break;
          }

          throw _iteratorError;

        case 27:
          return _context.finish(24);

        case 28:
          return _context.finish(21);

        case 29:
          return _context.delegateYield(iterateObject(map), "t1", 30);

        case 30:
        case "end":
          return _context.stop();
      }
    }
  }, _marked, null, [[3, 17, 21, 29], [22,, 24, 28]]);
}

function iterateSet(set) {
  var _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, value;

  return _regeneratorRuntime.wrap(function iterateSet$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _iteratorNormalCompletion2 = true;
          _didIteratorError2 = false;
          _iteratorError2 = undefined;
          _context2.prev = 3;
          _iterator2 = set[Symbol.iterator]();

        case 5:
          if (_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done) {
            _context2.next = 12;
            break;
          }

          value = _step2.value;
          _context2.next = 9;
          return inspect(value, true);

        case 9:
          _iteratorNormalCompletion2 = true;
          _context2.next = 5;
          break;

        case 12:
          _context2.next = 18;
          break;

        case 14:
          _context2.prev = 14;
          _context2.t0 = _context2["catch"](3);
          _didIteratorError2 = true;
          _iteratorError2 = _context2.t0;

        case 18:
          _context2.prev = 18;
          _context2.prev = 19;

          if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
            _iterator2.return();
          }

        case 21:
          _context2.prev = 21;

          if (!_didIteratorError2) {
            _context2.next = 24;
            break;
          }

          throw _iteratorError2;

        case 24:
          return _context2.finish(21);

        case 25:
          return _context2.finish(18);

        case 26:
          return _context2.delegateYield(iterateObject(set), "t1", 27);

        case 27:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2, null, [[3, 14, 18, 26], [19,, 21, 25]]);
}

function iterateImSet(set) {
  var _iteratorNormalCompletion3, _didIteratorError3, _iteratorError3, _iterator3, _step3, value;

  return _regeneratorRuntime.wrap(function iterateImSet$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _iteratorNormalCompletion3 = true;
          _didIteratorError3 = false;
          _iteratorError3 = undefined;
          _context3.prev = 3;
          _iterator3 = set[Symbol.iterator]();

        case 5:
          if (_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done) {
            _context3.next = 12;
            break;
          }

          value = _step3.value;
          _context3.next = 9;
          return inspect(value, true);

        case 9:
          _iteratorNormalCompletion3 = true;
          _context3.next = 5;
          break;

        case 12:
          _context3.next = 18;
          break;

        case 14:
          _context3.prev = 14;
          _context3.t0 = _context3["catch"](3);
          _didIteratorError3 = true;
          _iteratorError3 = _context3.t0;

        case 18:
          _context3.prev = 18;
          _context3.prev = 19;

          if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
            _iterator3.return();
          }

        case 21:
          _context3.prev = 21;

          if (!_didIteratorError3) {
            _context3.next = 24;
            break;
          }

          throw _iteratorError3;

        case 24:
          return _context3.finish(21);

        case 25:
          return _context3.finish(18);

        case 26:
        case "end":
          return _context3.stop();
      }
    }
  }, _marked3, null, [[3, 14, 18, 26], [19,, 21, 25]]);
}

function iterateImArray(array) {
  var i0, i1, n;
  return _regeneratorRuntime.wrap(function iterateImArray$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          i0 = -1, i1 = 0;
          n = array.size;

        case 2:
          if (!(i1 < n)) {
            _context4.next = 12;
            break;
          }

          if (!(i1 > i0 + 1)) {
            _context4.next = 6;
            break;
          }

          _context4.next = 6;
          return formatEmpty(i1 - i0 - 1);

        case 6:
          _context4.next = 8;
          return inspect(array.get(i1), true);

        case 8:
          i0 = i1;

        case 9:
          ++i1;
          _context4.next = 2;
          break;

        case 12:
          if (!(i1 > i0 + 1)) {
            _context4.next = 15;
            break;
          }

          _context4.next = 15;
          return formatEmpty(i1 - i0 - 1);

        case 15:
        case "end":
          return _context4.stop();
      }
    }
  }, _marked4);
}

function iterateArray(array) {
  var i0, i1, n, key, _iteratorNormalCompletion4, _didIteratorError4, _iteratorError4, _iterator4, _step4, symbol;

  return _regeneratorRuntime.wrap(function iterateArray$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          i0 = -1, i1 = 0;
          n = array.length;

        case 2:
          if (!(i1 < n)) {
            _context5.next = 13;
            break;
          }

          if (!(i1 in array)) {
            _context5.next = 10;
            break;
          }

          if (!(i1 > i0 + 1)) {
            _context5.next = 7;
            break;
          }

          _context5.next = 7;
          return formatEmpty(i1 - i0 - 1);

        case 7:
          _context5.next = 9;
          return inspect(valueof(array, i1), true);

        case 9:
          i0 = i1;

        case 10:
          ++i1;
          _context5.next = 2;
          break;

        case 13:
          if (!(i1 > i0 + 1)) {
            _context5.next = 16;
            break;
          }

          _context5.next = 16;
          return formatEmpty(i1 - i0 - 1);

        case 16:
          _context5.t0 = _regeneratorRuntime.keys(array);

        case 17:
          if ((_context5.t1 = _context5.t0()).done) {
            _context5.next = 24;
            break;
          }

          key = _context5.t1.value;

          if (!(!isindex(key) && isown(array, key))) {
            _context5.next = 22;
            break;
          }

          _context5.next = 22;
          return formatField(key, valueof(array, key), "observablehq--key");

        case 22:
          _context5.next = 17;
          break;

        case 24:
          _iteratorNormalCompletion4 = true;
          _didIteratorError4 = false;
          _iteratorError4 = undefined;
          _context5.prev = 27;
          _iterator4 = symbolsof(array)[Symbol.iterator]();

        case 29:
          if (_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done) {
            _context5.next = 36;
            break;
          }

          symbol = _step4.value;
          _context5.next = 33;
          return formatField(formatSymbol(symbol), valueof(array, symbol), "observablehq--symbol");

        case 33:
          _iteratorNormalCompletion4 = true;
          _context5.next = 29;
          break;

        case 36:
          _context5.next = 42;
          break;

        case 38:
          _context5.prev = 38;
          _context5.t2 = _context5["catch"](27);
          _didIteratorError4 = true;
          _iteratorError4 = _context5.t2;

        case 42:
          _context5.prev = 42;
          _context5.prev = 43;

          if (!_iteratorNormalCompletion4 && _iterator4.return != null) {
            _iterator4.return();
          }

        case 45:
          _context5.prev = 45;

          if (!_didIteratorError4) {
            _context5.next = 48;
            break;
          }

          throw _iteratorError4;

        case 48:
          return _context5.finish(45);

        case 49:
          return _context5.finish(42);

        case 50:
        case "end":
          return _context5.stop();
      }
    }
  }, _marked5, null, [[27, 38, 42, 50], [43,, 45, 49]]);
}

function iterateObject(object) {
  var key, _iteratorNormalCompletion5, _didIteratorError5, _iteratorError5, _iterator5, _step5, symbol;

  return _regeneratorRuntime.wrap(function iterateObject$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          _context6.t0 = _regeneratorRuntime.keys(object);

        case 1:
          if ((_context6.t1 = _context6.t0()).done) {
            _context6.next = 8;
            break;
          }

          key = _context6.t1.value;

          if (!isown(object, key)) {
            _context6.next = 6;
            break;
          }

          _context6.next = 6;
          return formatField(key, valueof(object, key), "observablehq--key");

        case 6:
          _context6.next = 1;
          break;

        case 8:
          _iteratorNormalCompletion5 = true;
          _didIteratorError5 = false;
          _iteratorError5 = undefined;
          _context6.prev = 11;
          _iterator5 = symbolsof(object)[Symbol.iterator]();

        case 13:
          if (_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done) {
            _context6.next = 20;
            break;
          }

          symbol = _step5.value;
          _context6.next = 17;
          return formatField(formatSymbol(symbol), valueof(object, symbol), "observablehq--symbol");

        case 17:
          _iteratorNormalCompletion5 = true;
          _context6.next = 13;
          break;

        case 20:
          _context6.next = 26;
          break;

        case 22:
          _context6.prev = 22;
          _context6.t2 = _context6["catch"](11);
          _didIteratorError5 = true;
          _iteratorError5 = _context6.t2;

        case 26:
          _context6.prev = 26;
          _context6.prev = 27;

          if (!_iteratorNormalCompletion5 && _iterator5.return != null) {
            _iterator5.return();
          }

        case 29:
          _context6.prev = 29;

          if (!_didIteratorError5) {
            _context6.next = 32;
            break;
          }

          throw _iteratorError5;

        case 32:
          return _context6.finish(29);

        case 33:
          return _context6.finish(26);

        case 34:
        case "end":
          return _context6.stop();
      }
    }
  }, _marked6, null, [[11, 22, 26, 34], [27,, 29, 33]]);
}

function iterateImObject(object) {
  var _iteratorNormalCompletion6, _didIteratorError6, _iteratorError6, _iterator6, _step6, _ref6, _ref5, key, value;

  return _regeneratorRuntime.wrap(function iterateImObject$(_context7) {
    while (1) {
      switch (_context7.prev = _context7.next) {
        case 0:
          _iteratorNormalCompletion6 = true;
          _didIteratorError6 = false;
          _iteratorError6 = undefined;
          _context7.prev = 3;
          _iterator6 = object[Symbol.iterator]();

        case 5:
          if (_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done) {
            _context7.next = 15;
            break;
          }

          _ref6 = _step6.value;
          _ref5 = _slicedToArray(_ref6, 2);
          key = _ref5[0];
          value = _ref5[1];
          _context7.next = 12;
          return formatField(key, value, "observablehq--key");

        case 12:
          _iteratorNormalCompletion6 = true;
          _context7.next = 5;
          break;

        case 15:
          _context7.next = 21;
          break;

        case 17:
          _context7.prev = 17;
          _context7.t0 = _context7["catch"](3);
          _didIteratorError6 = true;
          _iteratorError6 = _context7.t0;

        case 21:
          _context7.prev = 21;
          _context7.prev = 22;

          if (!_iteratorNormalCompletion6 && _iterator6.return != null) {
            _iterator6.return();
          }

        case 24:
          _context7.prev = 24;

          if (!_didIteratorError6) {
            _context7.next = 27;
            break;
          }

          throw _iteratorError6;

        case 27:
          return _context7.finish(24);

        case 28:
          return _context7.finish(21);

        case 29:
        case "end":
          return _context7.stop();
      }
    }
  }, _marked7, null, [[3, 17, 21, 29], [22,, 24, 28]]);
}

function formatEmpty(e) {
  var span = document.createElement("span");
  span.className = "observablehq--empty";
  span.textContent = e === 1 ? "empty" : "empty \xD7 ".concat(e);
  return span;
}

function formatField(key, value, className) {
  var fragment = document.createDocumentFragment();
  var span = fragment.appendChild(document.createElement("span"));
  span.className = className;
  span.textContent = key;
  fragment.appendChild(document.createTextNode(": "));
  fragment.appendChild(inspect(value, true));
  return fragment;
}

function formatMapField(key, value) {
  var fragment = document.createDocumentFragment();
  fragment.appendChild(inspect(key, true));
  fragment.appendChild(document.createTextNode(" => "));
  fragment.appendChild(inspect(value, true));
  return fragment;
}